<dt class="col-12">{{question}}</dt>
<dd class="col-12 d-flex">
    <div>{{answer}}</div>
    <a class="ms-auto edit-link" href="#" (click)="goBackTo($event)"
    [attr.aria-label]="editLinkAria">{{resources.editLinkText}}</a>
</dd>
